module.exports = __webpack_public_path__ + "img/Dantam Makeover 01.c0eca46e.jpg";